import React from 'react';
import { AdminLayout } from '../../../design-system/components/layouts';
import { PageHeader } from '../../../design-system/components';
import { admin_campaigns_path } from '../../../lib/routes';
import CampaignForm from './CampaignForm';
export default function New({ campaign }) {
  return (
    <AdminLayout>
      <PageHeader title="New Campaign" description="Create a new affiliate campaign" />

      <div className="mt-6">
        <CampaignForm campaign={campaign} action={admin_campaigns_path()} method="post" />
      </div>
    </AdminLayout>
  );
}
